const modal = {
  default: {
    overlay: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      opacity: 1,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      position: 'fixed',
      zIndex: 99
    },
    content: {
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'column nowrap',
      outline: 'none',
      position: 'relative',
      width: '70vw',
      minWidth: '250px',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }
};

export type ModalVariantsType = 'default';
export const modalVariants = Object.keys(modal) as ModalVariantsType[];

export default modal;
